export default "__VITE_ASSET__BJr5Fm7Z__"